import {LastResult} from '@hconnect/common/types'
import {formatNumber} from '@heidelbergmaterials/hproduce-number_formatting'
import {ErrorOutline} from '@mui/icons-material'
import {toNumber} from 'lodash'

import {isValueCorrectNumber, isValueError} from '../../utils/lastResult'


type Props = {
  language?: string
  lastResult?: LastResult
  prefix?: string
}

export const KpiLastResult = ({language, lastResult, prefix = ''}: Props) => {
  if (lastResult && isValueCorrectNumber(lastResult) && language) {
    return <>{`${prefix}${formatNumber(toNumber(lastResult.value), language)}`}</>
  }

  if (isValueError(lastResult)) {
    return (
      <ErrorOutline
        color="error"
        style={{fontSize: 16}}
        data-test-id="kpi-last-result-error-icon"
      />
    )
  }

  return <>{lastResult?.value || '-'}</>
}
